import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startFlightFavicon } from './ui/shell';
import './styles/global.css';

const host = document.getElementById('root');
if (!host) throw new Error('#root не найден в index.html');

// По иконке вкладки летает самолёт. Живёт вне React: это свойство документа,
// а не какого-то экрана, и переживает любые перерисовки.
startFlightFavicon();

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
